(() => {

const DISCOUNT_CODE = "SUBSCRIBER";
const STORAGE_KEY = "subscriber_discount_selection";

// Set to true right before WE (this script) programmatically submit the
// discount form, and for a short window after. While true, if the theme's
// own cart.js force-opens the discount accordion (it does this on every
// cart-discount form submission, including ours), we immediately close it
// again — using a MutationObserver so the correction happens before the
// browser paints, avoiding any visible open/close flicker. A customer who
// manually opens the box and types a real code is unaffected: this flag is
// only true during OUR programmatic click.
let awaitingAutoTrigger = false;
let awaitingAutoTriggerTimeout = null;

function getForms() {
    return document.querySelectorAll('form[is="cart-discount"]');
}

function saveSelection(value) {
    localStorage.setItem(STORAGE_KEY, value);
}

function getSelection() {
    return localStorage.getItem(STORAGE_KEY) || "subscribe";
}

function restoreSelection() {
    const selected = getSelection();

    document.querySelectorAll('[data-subscriber-option]').forEach(radio => {
        radio.checked = (radio.value === selected);
    });
}

function closeDiscountAccordions() {
    document.querySelectorAll('[id^="CartDiscount-"]').forEach(el => {
        el.removeAttribute('open');
        el.removeAttribute('active');
        el.setAttribute('aria-expanded', 'false');
    });
}

function armAutoTriggerWindow() {
    awaitingAutoTrigger = true;
    clearTimeout(awaitingAutoTriggerTimeout);
    // Safety net: clear the flag on its own after a few seconds even if no
    // cart:updated/mutation ever arrives, so a manual open later isn't
    // accidentally closed by a stale flag.
    awaitingAutoTriggerTimeout = setTimeout(() => {
        awaitingAutoTrigger = false;
    }, 4000);
}

// Watch for the cart/drawer HTML being replaced (cart.js does this via
// mainCart.innerHTML = ... / miniCart.innerHTML = ...) and, if our own
// auto-trigger is in-flight, strip the forced-open state the instant it
// appears — before the browser has a chance to render it.
const discountAccordionObserver = new MutationObserver(() => {
    if (!awaitingAutoTrigger) return;
    closeDiscountAccordions();
});
discountAccordionObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
});

function applyDiscount(form) {
    const input = form.querySelector('input[name="discount"]');
    const button = form.querySelector('button[type="submit"]');

    if (!input || !button) return;

    input.value = DISCOUNT_CODE;

    armAutoTriggerWindow();
    form.dataset.autoApply = "true";

    button.click();

    setTimeout(() => {
        delete form.dataset.autoApply;
    }, 0);
}

function removeDiscount(form) {
    const removeButton = [...form.querySelectorAll("[data-discount]")]
        .find(btn => btn.dataset.discount.toUpperCase() === DISCOUNT_CODE);

    if (removeButton) {
        armAutoTriggerWindow();
        removeButton.click();
    }
}

document.addEventListener("change", e => {
    if (!window.subscriberDiscountEnabled) return;

    const radio = e.target;

    if (!radio.matches("[data-subscriber-option]")) return;

    saveSelection(radio.value);

    getForms().forEach(form => {
        if (radio.value === "subscribe") {
            applyDiscount(form);
        } else {
            removeDiscount(form);
        }
    });
});

document.addEventListener("DOMContentLoaded", restoreSelection);

document.addEventListener("cart:updated", () => {
    setTimeout(() => {
        restoreSelection();

        if (awaitingAutoTrigger) {
            closeDiscountAccordions();
            awaitingAutoTrigger = false;
            clearTimeout(awaitingAutoTriggerTimeout);
        }
    }, 0);
});

document.addEventListener("ajaxProduct:added", () => {
    if (!window.subscriberDiscountEnabled) return;
    setTimeout(() => {
        const selected = getSelection();

        if (selected !== "subscribe") return;

        getForms().forEach(form => {
            const alreadyApplied = [...form.querySelectorAll("[data-discount]")].some(btn =>
                btn.dataset.discount.toUpperCase() === DISCOUNT_CODE
            );

            if (alreadyApplied) return;

            applyDiscount(form);
        });
    }, 0);
});

window.restoreSubscriberSelection = restoreSelection;
})();